import { Popover } from '@lightspeed/design-system-react'
import React from 'react'
import { DeleteButton } from '../../shared/DeleteButton'

export type CustomPopoverProps = {
  onClose: () => void
  title: string
  rows: CustomPopoverRowProp[]
}
export const CustomPopover = (props: CustomPopoverProps) => {
  const { title, rows, onClose } = props
  if (rows.length === 0) {
    return <></>
  }

  return (
    <Popover onClose={onClose} className="sale-popover">
      <h1 className="vd-text-label">{title}</h1>
      <hr className="vd-hr vd-mb0" />
      <table className="tax-group-table">
        <tbody>
          {rows.map(row => {
            return <CustomPopoverRow key={row.id} {...row} />
          })}
        </tbody>
      </table>
    </Popover>
  )
}

export type CustomPopoverRowProp = {
  id: string
  name: string
  value: string
  button: CustomPopoverRowButton
}
type CustomPopoverRowButton = {
  isVisible: boolean
  isDisable: boolean
  label: string
  onClick: (sourceId: string) => boolean
}
const CustomPopoverRow = (props: CustomPopoverRowProp) => {
  const {
    id,
    name,
    value,
    button: { isVisible, isDisable, label, onClick },
  } = props

  return (
    <>
      <tr key={id} className="tax-group">
        <td>
          <strong>{name}</strong>
        </td>
        <td className="tax-total sale-total-line-item--nowrap">{value}</td>
        <td>
          {isVisible && (
            <DeleteButton
              disabled={isDisable}
              aria-label={label}
              className="vd-btn vd-btn--icon-no"
              onClick={() => onClick(id)}
              modifier="icon"
              variant="supplementary"
            />
          )}
        </td>
      </tr>
    </>
  )
}
